import React from 'react';
import PropTypes from 'prop-types';

import { withTheme } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconSpeaker = ({ theme, ...otherProps }) => (
  <SvgIcon {...otherProps} viewBox="0 0 77.856239 94.670174">
    <polygon fill={theme.palette.primary[600]} transform="matrix(.75471 -.65606 .65606 .75471 -22.357 47.827)" points="74.391 33.641 72.764 59.515 40.23 48.353 38.604 32.051" />
    <polygon fill={theme.palette.primary[150]} transform="matrix(.75471 -.65606 .65606 .75471 -13.874 32.202)" points="57.737 39.941 56.111 13.309 23.577 24.799 21.95 39.941" />
    <polygon fill={theme.palette.primary[600]} transform="matrix(.75471 -.65606 .65606 .75471 -9.8065 54.641)" points="67.725 46.138 76.047 46.138 76.047 20.262 71.886 18.673 67.725 20.262" />
    <polygon fill={theme.palette.primary[150]} transform="matrix(.75471 -.65606 .65606 .75471 -1.323 39.017)" points="59.394 -0.067984 51.071 -0.067984 51.071 26.564 59.394 26.564" />
    <path fill={theme.palette.primary[700]} d="m27.266 67.001 13.344 10.386l1.4319-3.9373c0.78759-2.1653-0.0078-5.5934-1.7676-7.6178l-3.9539-4.5485-9.0544 5.7168z" />
    <polygon fill={theme.palette.primary[700]} transform="matrix(.75471 -.65606 .65606 .75471 -47.45 45.827)" points="36.799 93.377 38.427 63.303 45.754 66.555 45.754 91.752" />
    <polygon fill={theme.palette.primary[500]} transform="matrix(.75471 -.65606 .65606 .75471 -51.459 43.65)" points="32.697 96.025 32.697 70.828 40.025 67.576 40.025 97.651" />
    <polygon fill={theme.palette.primary[700]} transform="matrix(.75471 -.65606 .65606 .75471 -53.249 55.311)" points="56.353 93.275 49.025 93.275 45.768 90.836 49.025 88.398 56.353 88.398" />
    <polygon fill={theme.palette.primary[600]} transform="matrix(.75471 -.65606 .65606 .75471 -40.249 33.759)" points="17.748 71.008 16.119 54.345 41.358 54.345 39.73 71.008" />
    <polygon fill={theme.palette.primary[150]} transform="matrix(.75471 -.65606 .65606 .75471 -35.495 25.004)" points="6.7873 59.46 8.4156 44.423 30.398 44.423 32.026 59.46" />
    <path fill={theme.palette.primary[600]} d="m15.586 76.523c-2.254 0.479-5.538-0.786-7.2978-2.811l-3.9539-4.5485 0.63205-4.8573 4.898 0.05011 9.8199 11.296s-1.8442 0.39151-4.0982 0.86996" />
    <polygon fill={theme.palette.primary[150]} transform="matrix(.75471 -.65606 .65606 .75471 -31.98 38.249)" points="41.32 62.194 36.435 62.194 36.435 47.157 38.877 45.532 41.32 47.157" />
    <polygon fill={theme.palette.common.white} transform="matrix(.75471 -.65606 .65606 .75471 -27.226 29.493)" points="31.988 35.609 27.103 35.609 27.103 50.646 31.988 50.646" />
  </SvgIcon>
);

IconSpeaker.propTypes = {
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      primary: PropTypes.shape({
        150: PropTypes.string.isRequired,
        500: PropTypes.string.isRequired,
        600: PropTypes.string.isRequired,
      }).isRequired,
      common: PropTypes.shape({
        white: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default withTheme()(IconSpeaker);



// WEBPACK FOOTER //
// ./src/components/icons/IconSpeaker.js